<template>
    <nuxt-link
        :class="{
            'flex items-center gap-2': true,
            'whitespace-nowrap px-6 py-3 text-left text-gray-800': true,
            'disabled:pointer-events-none disabled:text-gray-400': true,
            'hover:bg-gray-200 hover:text-gray-900 hover:no-underline': true,
            'focus:bg-gray-100 focus:text-gray-900 focus:no-underline': true,
            'active:bg-primary-400 active:text-white active:no-underline': true
        }"
        role="menuitem"
        :disabled="disabled"
        :to="to"
        :target="target"
    >
        <slot>
            {{ label }}
        </slot>
    </nuxt-link>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import NuxtLink from '#app/components/nuxt-link'

export default defineComponent({
    name: 'PopupMenuLink',
    components: { NuxtLink },

    props: {
        label: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        to: {
            type: [String, Object] as PropType<RouteLocationRaw>,
            required: true
        },
        target: {
            type: String,
            default: () => undefined
        }
    }
})
</script>
